<template>
    <h1>Documents</h1>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'

export default {
}
</script>
